<template lang="pug">
  div.editable-wrapper
    b-form-select(
      v-if="list && state===1"
      ref="selectbox"
      size="sm"
      v-model="select"
      :options="list"
      style="width: auto"
    )
    input.editable-text(
      v-if="!hideInput"
      ref="inputbox",
      type="text",
      autocomplete="off",
      autocorrect="off",
      autocapitalize="off",
      spellcheck="false",
      placeholder="-",
      v-model="text",
      :maxlength="limit",
      :class="{'no-value': !value}",
      :disabled="state!==1",
      @keydown="validate")
    transition-group.edit-buttons(
      v-if="!disabled"
      name="editable",
      mode="out-in",
      tag="div")
      button.plain-button.editable-button(v-if="state===0", @click="edit", key="edit")
        icon(name="edit", scale="1.3")
      button.plain-button.editable-button(v-if="state===2", key="wait")
        icon(name="spinner", scale="1.3", spin)
      button.plain-button.editable-button(v-if="state===1", @click="cancel", key="cancel")
        icon(name="times-circle", scale="1.3")
      button.plain-button.editable-button(v-if="state===1", @click="submit", key="submit")
        icon(name="check", scale="1.3")
</template>

<script>
export default {
  name: "editable",
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
    },
    pk: {
      type: [String, Number],
    },
    selected: {
      type: [String, Number],
    },
    list: {
      type: Array,
    },
    wait: {
      type: Boolean,
      default: false,
    },
    available: {
      type: RegExp,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 100,
    },
  },
  computed: {
    hideInput() {
      return this.list && this.state === 1
    },
  },
  watch: {
    value: function(newValue) {
      if (newValue !== undefined) this.text = newValue
    },
    selected: function(newValue) {
      if (newValue !== undefined) this.select = newValue
    },
    wait(n) {
      if (n) {
        this.store = this.state
        this.state = 2
      } else {
        this.state = this.store
      }
    },
  },
  mounted() {
    this.text = this.value
    this.select = this.selected
  },
  data() {
    return {
      store: 0,
      state: 0,
      text: "",
      select: "",
    }
  },
  methods: {
    edit() {
      this.state = 1
      this.$nextTick(() => {
        if (this.$refs.inputbox) this.$refs.inputbox.focus()
        if (this.$refs.selectbox) this.$refs.selectbox.focus()
      })
      if (this.name === "approver_name") {
        let valueSplit = this.text.split("(")
        this.text = valueSplit[0]
      }
      this.$emit("edit", true)
    },
    validate(evt) {
      if (!this.available) return
      const { key, which, keyCode } = evt
      const code = which || keyCode
      if (key.length === 1 && !this.available.test(key)) {
        evt.preventDefault()
        this.$log.info(`[NOT ALLOWED KEY: ${key}(${code})]`)
      }
    },
    cancel() {
      this.state = 0
      this.text = this.value
      this.$emit("edit", false)
    },
    submit() {
      this.state = 0
      if (this.list) {
        this.text = this.list.find(item => item.value === this.select).text
        this.$emit("changed", this.name, this.select, this.pk)
      } else {
        this.$emit("changed", this.name, this.text, this.pk)
      }
      this.$emit("edit", false)
      // if (this.name === 'approver_name') {
      //   this.text = this.value
      // }
    },
  },
}
</script>

<style lang="scss">
.editable-wrapper {
  display: inline-block;
  width: 100%;
  .editable-text {
    border: 0;
    width: 100%;
    background-color: transparent;
    outline: none;
    color: #6092d2;
    font-size: inherit;
    display: inline-block;
    &:disabled {
      //color: #2c3e50;
      color: #000000;
    }
    &::placeholder {
      color: #cacaca;
      font-style: italic;
    }
  }
  .edit-buttons {
    position: absolute;
    top: -1px;
    right: 5px;

    svg {
      color: #888;
    }
  }
}

.editable-button {
  transition: transform 500ms, opacity 500ms;
}
.editable-enter {
  transform: translateX(20px);
  opacity: 0;
}
.editable-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}
.editable-leave-active {
  position: absolute;
}
</style>
